import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "", align = "left" }) => (
  <span
    className={`inline-flex items-center gap-3 text-[12px] subhead ${className}`}
    style={{ justifyContent: align === "center" ? "center" : "flex-start" }}
  >
    <span className="h-px w-8 bg-mds-gold/50" aria-hidden="true" />
    {children}
    {align === "center" && <span className="h-px w-8 bg-mds-gold/50" aria-hidden="true" />}
  </span>
);
